import Marquee from "react-fast-marquee";

export default function EditorialMarquee() {
  const words = ["MYYNTI", "VAIHTO", "OSTO", "RAHOITUS"];
  return (
    <div className="py-10 border-y border-white/10 bg-[#050505] overflow-hidden" data-testid="marquee">
      <Marquee speed={40} gradient={false}>
        {words.map((w, i) => (
          <span key={i} className="font-display text-white text-5xl md:text-7xl mx-8 uppercase tracking-tight inline-flex items-center">
            {w}
            <span className="inline-block h-3 w-3 md:h-4 md:w-4 rounded-full bg-[#ff5a00] ml-16" />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
